function setCSSVars() {
  const header = document.querySelector('[data-site-header]');
  const headerHeight = header?.offsetHeight || 0;
  const windowHeight = window.innerHeight;

  document.documentElement.style.setProperty(
    '--window-height',
    `${windowHeight}px`
  );
  document.documentElement.style.setProperty(
    '--header-height',
    `${headerHeight}px`
  );
}

function setHeroHeight() {
  const vh = (window.visualViewport?.height || window.innerHeight) * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setHeroHeight();
window.addEventListener('orientationchange', setHeroHeight);


// Initial set
setCSSVars();
function headerHeight() {
  const header = document.querySelector('[data-site-header]');
  const height = header ? header.offsetHeight : 150;
  return height;
}
// Responsive updates
window.addEventListener('resize', debounce(setCSSVars, 100));

window.addEventListener(
  'scroll',
  debounce(() => {
    const header = document.querySelector('[data-site-header]');
    const headerHeight = header?.offsetHeight || 0;
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
  }, 50)
);

/************ STICKY HEADER ***************/
const siteHeader = document.querySelector('[data-site-header]');
if (!siteHeader) { 
  console.warn('No [data-site-header] found.');
} else {
  function fixHeader() {
    const stickyOffset = siteHeader.offsetHeight + 200;
    const isScrolled = window.scrollY > stickyOffset;
    siteHeader.classList.toggle('scrolling', isScrolled);
    siteHeader.classList.toggle('fixed', isScrolled);
  }

  const handleScrollResize = debounce(fixHeader, 50);
  window.addEventListener('load', fixHeader);
  ['scroll', 'resize', 'touchmove'].forEach((event) =>
    window.addEventListener(event, handleScrollResize)
  );
}

/************ Smooth Scroll  ****************/

document
  .querySelectorAll(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])'
  )
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('scroll to ', e);
      const offset = headerHeight() * -2;
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = anchor.hash;
        target = target.length
          ? target
          : document.querySelector(`[name="${this.hash.slice(1)}"]`);

        if (target.length) {
          const element = document.getElementById(target.replace('#', ''));
          console.log('element', element);
          window.scrollTo({
            top: getOffsetTop(element) + offset,
            left: 0,
            behavior: 'smooth',
          });

          element.focus();
        }
      }
    });
  });

function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}

document.querySelector('body').classList.remove('loading');

// BD ALLY UPDATES
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    const target = event.target.closest('[data-button]');
    if (target) {
      event.preventDefault();
      event.target.click();
    }
  }
});

class VideoControls extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const toggleBtn = event.target.closest('[data-toggle]');
    if (!toggleBtn) return;

    const container = toggleBtn.closest('[data-background-video]');
    if (!container) return;

    const videos = container.querySelectorAll('video');
    if (!videos.length) return;

    const iconPlay = toggleBtn.querySelector('.icon-play');
    const iconPause = toggleBtn.querySelector('.icon-pause');
    if (!iconPlay || !iconPause) return;

    const isPlaying = !iconPause.classList.contains('visually-hidden');

    videos.forEach(video => {
      if (isPlaying) {
        video.pause();
        this.toggleIcons(iconPlay, iconPause);
        toggleBtn.setAttribute('aria-label', 'play');
      } else {
        video.play()
          .then(() => {
            this.toggleIcons(iconPause, iconPlay);
            toggleBtn.setAttribute('aria-label', 'pause');
          })
          .catch(err => console.warn('Play failed:', err));
      }
    });
  }

  toggleIcons(show, hide) {
    show.classList.remove('visually-hidden');
    hide.classList.add('visually-hidden');
    show.removeAttribute('aria-hidden');
    show.removeAttribute('inert');
    hide.setAttribute('aria-hidden', 'true');
    hide.setAttribute('inert', '');
  }
}

customElements.define('video-controls', VideoControls);



function bindMediaLoaders(scope = document) {
  const imageContainers = scope.querySelectorAll('.image');

  imageContainers.forEach((container) => {
    const img = container.querySelector('img');
    const video = container.querySelector('video');
    const loader = container.querySelector('.loader');

    if (img) {
      if (img.complete) {
        loader?.remove();
      } else {
        img.addEventListener('load', () => loader?.remove());
      }
    }

    if (video) {
      if (video.readyState >= 2) {
        loader?.remove();
      } else {
        video.addEventListener('loadeddata', () => loader?.remove());
      }
    }
  });
}

bindMediaLoaders();